import { Loader } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { useRouter } from 'next/router';

import SEO from '../../../src/components/SEO';
import User from '../../../src/components/ptt/User';
import NavBar from '../../../src/components/NavBar';
import { selectFirebaseAuthed, selectFirebaseAuthIsLoaded } from '../../../src/selectors';

const PTTUser = (props: any) => {
  const router = useRouter();
  const { pid } = router.query;

  // SEO
  const metaTitle = `PTT | ${pid}`;
  const metaDescription = `PTT ID ${pid} 的近期活動情行, 發推噓文, IP 熱點分佈`;

  const {
    authIsLoaded,
    authed,
  } = props;

  return (
    <>
      <SEO
        title={metaTitle}
        description={metaDescription}
      />
      <NavBar isFetching={!authIsLoaded} authed={authed} export>
        {!authIsLoaded ? (
          <Loader active inline="centered" />
        ) : (
          <User authed={authed} id={pid} />
        )}
      </NavBar>
    </>
  );
};

const mapStateToProps = (state: any) => ({
  authIsLoaded: selectFirebaseAuthIsLoaded(state),
  authed: selectFirebaseAuthed(state),
});

export default connect(mapStateToProps)(PTTUser);
